import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, DatePicker, Table, Button } from "antd";
import { Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { dropdownService, VCPaymentService } from "../../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from '../../../../utils/printing'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { changeDocumentTitle } from "../../../../utils/title";

function VendorContainerPayment() {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(null)
  const [vcpayments, setVCPayments] = useState([]);
  const [allvcpayments, setAllVCPayments] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [form] = Form.useForm();

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Container Id",
      dataIndex: "container_id",
      key: "container_id",
    },
    {
      title: "Vendor",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Fright Charges",
      dataIndex: "freight_charges",
      key: "freight_charges",
      render: (text) => "$" + text,
    },
    {
      title: "Chassis",
      dataIndex: "chassis_charges",
      key: "chassis_charges",
      render: (text) => "$" + text,
    },

    {
      title: "Total",
      dataIndex: "total_charges",
      key: "total_charges",
      render: (text) => "$" + text,
    },
  ];

  const onFinish = (values) => {
    const data = {
      ...values,
      from_date: values.from_date
        ? values.from_date.format("YYYY-MM-DD")
        : null,
      to_date: values.to_date ? values.to_date.format("YYYY-MM-DD") : null,
    };

    initialize(pagination.current, pagination.pageSize, data);
  };


  const getVendors = async () => {
    const response = await dropdownService.fetchVendors();
    if (response.success) {
      setVendors(response.data);
    }
  };

  const getAll = async (data) => {
    const response = await VCPaymentService.fetch(1, data, true)
    if (response.success) {
      const numberedData = response.data.data.map((item, index) => ({
        ...item,
        "#": index + 1,
      }));
      setAllVCPayments(numberedData)
    }
  }

  const initialize = async (
    page = 1,
    pageSize = pagination.current,
    data = null
  ) => {
    setLoading(true);
    const response = await VCPaymentService.fetch(page, data);
    if (response.success) {
      setVCPayments(response.data.data.data);
      setTotal(response.data.data.total)
      setPagination((prev) => ({
        ...prev,
        total: response.data.data.total,
        current: page,
        pageSize,
      }));
      setLoading(false);
    }
    getAll(data);
  };



  useEffect(() => {
    changeDocumentTitle("Vendors Container Payments");
    initialize(pagination.current, pagination.pageSize);
    getVendors();
  }, [pagination.current, pagination.pageSize]);


  return (
    <div
      style={{
        padding: "0 14px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row
        gutter={24}
        style={{
          marginBottom: 15,
          padding: "10px",
          borderRadius: "4px",
          borderBottom: "1px solid #E8E8E9",
        }}
      >
        <Col span={24}>
          <h1 style={{ fontWeight: "bold" }}> Vendors Containers Payment</h1>
        </Col>
      </Row>

      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item label="From Date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="To Date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Vendor"
              name="vendor_id"
              rules={[
                {
                  required: true,
                  message: "Please input!",
                },
              ]}
            >
              <Select placeholder="No Vendor">
                {vendors.map((vendor) => (
                  <Select.Option key={vendor.id} value={vendor.id}>
                    {vendor.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
            >
              <SearchOutlined />
            </Button>
          </div>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={22}
          style={{
            padding: "10px",
            marginTop: "10px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={10}>
            <div className='flex' >
              <Button onClick={() => handlePrint(allvcpayments, columns, "Vendors Container Payment Report")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              <Button onClick={() => exportToExcel(allvcpayments, "vendor_container_payment.xlsx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allvcpayments, columns, "Vendors Container Payment Report", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

            </div>
          </Col>
          <Col span={14} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              style={{ width: 200 }}
            />
          </Col>
        </Row>
        <div id="printable-table">
          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            dataSource={vcpayments}
            loading={loading}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize),
              showSizeChanger: false,
            }}
            rowKey={(record, index) => index}
            style={{ marginTop: "10px" }}
          />
          <div
            className="flex justify-end gap-32 mt-5 mb-5"
            style={{ fontWeight: "bold" }}
          >
            <p>Total Amount Collected :</p>
            <p>${total}</p>
          </div>
        </div>
      </Col>
    </div>
  );
}

export default VendorContainerPayment;
